import {toast} from "@/shared/plugins/toastr";
import {createClient, fetchClient, updateClient} from "@/services/client";
import {cloneDeep} from "lodash";

export const clientMixin = {
  props: {
    clientId: {
      type: Number
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    submit() {
      this.$v.clientData.$touch()
      if(this.$v.clientData.$invalid){
        toast({
          'title': this.$t('VALIDATION_FAILED'),
          'message': null,
          'type': 'error',
          'timeout': 6000
        })
        return
      }
      this.loading = true;
      if(this.clientId) {
        updateClient(this.clientId, this.clientData).then(() => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$emit('success')
        }, (error) => {
          toast({
            'title': "Greška",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=> {
          this.loading = false;
        })
      } else {
        createClient(this.clientData).then(() => {
          toast({
            'title': this.$t('NOTIFICATIONS.SAVE_SUCCESS.MESSAGE'),
            'type': 'success',
            'timeout': 2000
          })
          this.$emit('success')
        }, (error) => {
          toast({
            'title': "Greška",
            'message': this.getMessages(error),
            'type': 'error',
            'timeout': 6000
          })
        }).finally(()=> {
          this.loading = false;
        })
      }
    }
  },
  mounted() {
    if(this.clientId) {
      fetchClient(this.clientId).then((response) => {
        this.clientData = response.data;
      })
    }
  }
}
